import React from "react";

export type FieldErrorProps = {
  id: string; // エラー要素ID（inputのaria-describedbyで参照）
  isVisible: boolean; // 表示制御（trueのときのみ描画）
  message?: string; // 表示するメッセージ（未指定なら非表示）
  className?: string; // 既存デザインに合わせるクラス（デフォルトあり）
};

export function FieldError({
  id,
  message,
  isVisible,
  className,
}: FieldErrorProps) {
  // 表示制御は isVisible を優先し、メッセージが空白のみの場合も非表示
  const visible = Boolean(isVisible) && Boolean(message?.trim());
  if (!visible) return null;
  return (
    <p
      id={id}
      role="alert"
      aria-live="polite"
      className={className ?? "text-red-600 text-sm"}
    >
      {message}
    </p>
  );
}

export default FieldError;
